import React from 'react';
import { Stack } from '@mui/material';
import BusinessProfilesTable from '../components/BusinessProfilesTable';
import TopBar from "../../../components/TopBar";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import useBusinessProfileFilters from "../components/BusinessProfilesFilterHelper";
import BusinessListPageActions from "../components/BusinessListPageActions";

function BusinessProfileListPage() {
    const {
        currentQuery,
        handlePaginationChange,
    } = useBusinessProfileFilters({ defaultQuery: {} });
    useDocumentTitle('Business Profile List');
    return (
        <Stack direction="column" sx={{ mt: '-1rem' }}>
            <TopBar title={'Business Profiles'}><BusinessListPageActions /></TopBar>
            <BusinessProfilesTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery}/>
        </Stack>
    );
}

export default BusinessProfileListPage;
